import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LgvModel } from '../../data-models/longevity.model';
import { StdObj } from '../../data-models/standard-objects';

@Injectable({
    providedIn: 'root'
})

export class LgvConstants {
    static EmptyGuid = '00000000-0000-0000-0000-000000000000';
    static ClientProfileWarning = 'Updating financial details may impact the loan options available and the current options won’t reflect the latest data. Your loan officer will review the changes and re-select available loans if needed.';

    static BlobBaseUrl = 'https://hdprodwestst.blob.core.windows.net/';
    static BlobSharedImagesBaseUrl = LgvConstants.BlobBaseUrl + 'shared-images/';

    static SocialMediaOptions(): StdObj.ListItem[] {
        let rtnVal = [];
        for (const value in SocialMediaType) {
            rtnVal.push({ ID: SocialMediaType[value], Display: value });
        }
        return rtnVal;
    }

    static SocialMediaNameFromID(key: string): string {
        if (!(!!key)) { return null; }
        let options = this.SocialMediaOptions();
        let result = options.find(x => x.ID === key.toUpperCase());
        return !!result ? result.Display : null;
    }

    static isRealEstateBusinessType(typeId: string): boolean { return !!typeId && typeId.toUpperCase() === BusinessType.RealEstate; }
    static isMortgageLenderBusinessType(typeId: string): boolean { return !!typeId && typeId.toUpperCase() === BusinessType.MortgageLender; }

    isEmailDisclaimer(disc: LgvModel.Disclosure): boolean { return !!disc && !!disc.contentLocations && !!disc.contentLocations.find(x => x.id.toUpperCase() === ContentLocation.Email) }
    isFooterDisclaimer(disc: LgvModel.Disclosure): boolean { return !!disc && !!disc.contentLocations && !!disc.contentLocations.find(x => x.id.toUpperCase() === ContentLocation.Footer) }
    isLinkDisclaimer(disc: LgvModel.Disclosure): boolean { return disc.typeId.toUpperCase() === DisclosureType.Link; }
    isTextDisclaimer(disc: LgvModel.Disclosure): boolean { return disc.typeId.toUpperCase() === DisclosureType.Text; }
    isTextFooterDisclaimer(disc: LgvModel.Disclosure): boolean { return this.isTextDisclaimer(disc) && this.isFooterDisclaimer(disc); }
    isLinkFooterDisclaimer(disc: LgvModel.Disclosure): boolean { return this.isLinkDisclaimer(disc) && this.isFooterDisclaimer(disc); }
    isTextEmailDisclaimer(disc: LgvModel.Disclosure): boolean { return this.isTextDisclaimer(disc) && this.isEmailDisclaimer(disc); }

    static TaskType1003= '4bcca072-892d-ef11-86c3-0022480a0f6b';
}

export enum ProviderType {
    Pricing = 'Pricing', Insurance = 'Insurance', LoanApplications = 'LoanApplications', PublicRecords = 'PublicRecords', Valuation = 'Valuation'
}

export enum ContentLocation {
    Email = 'C92D2DFE-8E15-EE11-907C-000D3A37C5E2',
    Footer = 'D644A807-8F15-EE11-907C-000D3A37C5E2'
}

export enum DisclosureType {
    Text = 'AD5175A9-8AB8-ED11-A8E0-000D3A5BB6BA',
    Link = 'BC7F7CB1-8AB8-ED11-A8E0-000D3A5BB6BA'
}

export enum TaskStatus {
    Requested = 'B3C265C4-FFD1-EE11-85F7-6045BD020C58',
    Rejected = 'B4C265C4-FFD1-EE11-85F7-6045BD020C58',
    Accepted = 'B5C265C4-FFD1-EE11-85F7-6045BD020C58',
    Uploaded = 'B6C265C4-FFD1-EE11-85F7-6045BD020C58',
    Submitted = 'B7C265C4-FFD1-EE11-85F7-6045BD020C58'
}

export enum SocialMediaType {
    Facebook = 'CF3284E6-D0CF-ED11-9F73-000D3A5BBF81',
    XTwitter = 'D03284E6-D0CF-ED11-9F73-000D3A5BBF81',
    //XTwitter = '6FEC04D2-CAE8-44C1-9D41-800B6CDA4C48',
    Threads = '47CC544E-32C8-4E05-AEF1-D04028C8C8CE',
    Google = 'D13284E6-D0CF-ED11-9F73-000D3A5BBF81',
    LinkedIn = 'D23284E6-D0CF-ED11-9F73-000D3A5BBF81',
    Youtube = 'D33284E6-D0CF-ED11-9F73-000D3A5BBF81',
    Instagram = 'D43284E6-D0CF-ED11-9F73-000D3A5BBF81',
    Zillow = 'D53284E6-D0CF-ED11-9F73-000D3A5BBF81',
    Yelp = 'D63284E6-D0CF-ED11-9F73-000D3A5BBF81'
}

export enum BusinessType {
    MortgageLender = 'B053507B-328F-EA11-86E9-000D3A328C22',
    RealEstate = '00C412CB-328F-EA11-86E9-000D3A328C22'
}

export enum BrandingColorAttribute {
    PrimaryColor = 'CD30BBBC-0EDB-ED11-9F71-000D3A37C2DB',
    SecondaryColor = 'CE30BBBC-0EDB-ED11-9F71-000D3A37C2DB',
    HeaderColor = 'asdf',
    FooterColor = 'aaa',
    LinkColor = 'bbb'
}



//export enum HDImageType {
//    User_Profile = 'User_Profile',
//    Company_PrimaryDark = 'Company_PrimaryDark',
//    Company_PrimaryLight = 'Company_PrimaryLight',
//    Company_Square = 'Company_Square',
//    Company_Favicon = 'Company_Favicon'
//}
